export default "__VITE_ASSET__$e1f8oulJwVfBHw_3aYc1w__"